/*--------------
V 1.0.0 - Criado por Marco Antônio

DESCIÇÃO:
Service para funções compartilhadas da aplicação
--------------*/

import { Injectable } from '@angular/core';

@Injectable()
export class SharedService {

  constructor() { }

  upperCase(text){
    if(text === null || text === undefined || typeof(text) !=="string"){
      return text;
    }
      return text.toUpperCase();
  }

  verificaData(n){

    let dia = n.substr(0,2);
    let mes = n.substr(3,2);
    let ano = n.substr(6,4);

    if( (n.length == 10) && (mes != '00') && (mes <= '12') && (ano > '1500')  ){

      switch (mes) {
        case '01': if  ((dia <= 31) && (dia != 0)) 
           return (true); 	 
         break; 

        case '02': if  ((dia <= 29) && (dia != 0))
           return (true); 	         
          break;

        case '03': if  ((dia <= 31) && (dia != 0))
           return (true);
          break;  

        case '04': if  ((dia <= 30)  && (dia != 0))
           return (true); 	 
          break;  

        case '05': if  ((dia <= 31) && (dia != 0))
           return (true); 	 
          break;  

        case '06': if  ((dia <= 30) && (dia != 0))
           return (true); 	 
          break;

        case '07': if  ((dia <= 31) && (dia != 0))
           return (true); 	 
          break;  

        case '08': if  ((dia <= 31) && (dia != 0))
           return (true); 	 
          break;  

        case '09': if  ((dia <= 30) && (dia != 0))
           return (true); 	 
          break;  
        case '10': if  ((dia <= 31) && (dia != 0))
           return (true); 	 
          break;  

        case '11': if  ((dia <= 30) && (dia != 0))    
           return (true); 	 
          break; 

        case '12': if  ((dia <= 31) && (dia != 0))
           return (true); 	 
          break;	
        }  
      return false;	

    }else{
      return false;
    }
  }   
   

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts